import { render } from "./ChatRoom.vue?vue&type=template&id=045f031d&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"

import "./ChatRoom.vue?vue&type=style&index=0&id=045f031d&scoped=true&lang=css"

import exportComponent from "/home/magpie/dnd/client/gamemasterai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045f031d"]])

export default __exports__